import ShieldIcon from 'components/icons/ShieldIcon';
import WithlocalsLogoSmall from 'components/icons/WithlocalsLogoSmall';
import React from 'react';
import { useTrekker } from 'utils/analytics';
import { openExternalLink } from 'utils/openExternalLink';

const CSS = require('./SafetyMessage.module.scss');

const URL = 'https://support.withlocals.com/hc/en-us/articles/12253797334556';

function SafetyMessage() {
  const trekker = useTrekker();

  const onClick = () => {
    trekker.event('click', {
      component: ['SafetyMessage'],
      buttonText: 'learn more',
    });
    openExternalLink(URL);
  };

  return (
    <div className={CSS.SafetyMessage}>
      <span className={CSS.IconContainer}>
        <ShieldIcon className={CSS.ShieldIcon} />
        <WithlocalsLogoSmall color="#E71575" className={CSS.WithlocalsLogo} />
      </span>
      <p className={CSS.Message}>
        For your safety, always communicate and transfer money via the
        Withlocals website or app.
        <button type="button" onClick={onClick} className={CSS.LearnMore}>
          Learn more
        </button>
      </p>
    </div>
  );
}

export default SafetyMessage;
